module.exports = "/subscriptions/assets/63514dfe3f4cc81b0791dbd74d288f3c.png";